<template>
    <div class="query-table" :class="{ 'query-table-two-column': twoColumn }">
        <!-- 双列布局 -->
        <div v-if="twoColumn" class="two-column-wrapper">
            <table class="two-column-table">
                <thead>
                    <tr>
                        <th>题目</th>
                        <th>得分</th>
                        <th>题目</th>
                        <th>得分</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in leftColumnData" :key="index">
                        <td>{{ row.title }}</td>
                        <td>{{ row.score }}</td>
                        <td>{{ rightColumnData[index]?.title || '' }}</td>
                        <td>{{ rightColumnData[index]?.score || '' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 原始单列布局 -->
        <el-table v-else :data="model.data" border style="width: 100%" :span-method="spanMethod"
            :highlight-current-row="false">
            <el-table-column v-for="(item, index) in model.rule" :key="index" :prop="item.prop" :label="item.label"
                :width="item.width">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {

    props: {
        model: Object,
        twoColumn: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        leftColumnData() {
            if (!this.model?.data) return [];
            const half = Math.ceil(this.model.data.length / 2);
            return this.model.data.slice(0, half);
        },
        rightColumnData() {
            if (!this.model?.data) return [];
            const half = Math.ceil(this.model.data.length / 2);
            return this.model.data.slice(half);
        }
    },

    methods: {
        spanMethod({ row, column, rowIndex, columnIndex }) {
            switch (this.model.type) {
                case QUERY_TYPE.OSA_18:
                case QUERY_TYPE.PSQ:
                    //按纬度分
                    if (columnIndex === 0) {
                        const lastDepth = this.model.data[rowIndex - 1]?.depth
                        if (lastDepth != row.depth) {
                            var rowSpan = 0
                            this.model.data.forEach((item, index) => {
                                if (item.depth == row.depth) {
                                    rowSpan += 1
                                }
                            });
                            return {
                                rowspan: rowSpan,
                                colspan: 1
                            };
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        }
                    }
                default:
                    break;
            }
        }

    }

}
</script>

<style lang="scss" scoped>
.query-table {
    width: 100%;

    /deep/.el-table .el-table__cell {
        padding: 4px 0;
    }

    /deep/.el-table tbody tr:hover>td {
        background-color: unset !important;
    }

    /deep/.el-table tr.current-row>td.el-table__cell {
        background-color: unset !important;
    }


    /deep/.el-table {
        border-bottom: 1px solid #979797;
        border-right: 1px solid #979797;
        margin: 0 auto;
    }

    /deep/.el-table td,
    /deep/.el-table th {
        border: 1px solid #979797 !important;
        border-right: none !important;
        border-bottom: none !important;
    }

    /deep/.el-table th.el-table__cell>.cell {
        color: black;
        font-size: 14px;
        font-weight: bold;

    }

    /deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
        color: black;
        font-size: 14px;
    }
}

.query-table-two-column {
    .two-column-wrapper {
        width: 100%;
    }

    .two-column-table {
        width: 100%;
        border-collapse: collapse;

        th, td {
            border: 1px solid #979797;
            padding: 4px 8px;
            font-size: 14px;
            color: black;
        }

        th {
            font-weight: bold;
            background-color: #f5f5f5;
        }

        td:nth-child(1), td:nth-child(3) {
            width: 35%;
        }

        td:nth-child(2), td:nth-child(4) {
            width: 15%;
            text-align: center;
        }
    }
}
</style>